<ng-container *ngIf="recipientOptions">

    <div class="row">
        <div class="col-sm-10 col-md-10 col-lg-11">
            <div class="smp-title-thin-border mb-3">{{ 'recipient_options_management.title.edit_recipient_options' | translate }}</div>
        </div>
    </div>

    <div class="row" >
        <div class="col-md-12 col-lg-6">
            <div class="row">
                <div class="col-sm-10">
                    <mat-form-field class="full-width">
                        <mat-label>{{ recipientOptions.trans.recipient_name | translate }}</mat-label>
                        <input id="{{idPrefix}}input_text.{{recipientOptions.trans.recipient_name}}"
                               type="text" matInput
                               [(ngModel)]="recipientOptions.recipient_name"
                               [disabled]="disabled">
                    </mat-form-field>
                </div>

                <div class="col-sm-2">
                    <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                </div>
            </div>

            <div class="row">
                <div class="col-sm-10">
                    <mat-form-field class="full-width">
                        <mat-label>{{ recipientOptions.trans.channel | translate }}</mat-label>
                        <mat-select id="{{idPrefix}}input_select.{{recipientOptions.trans.channel}}"
                                    [(ngModel)]="selectedChannel"
                                    [disabled]="disabled">
                            <mat-option *ngFor="let item of channels"
                                        id="{{idPrefix}}input_select.{{recipientOptions.trans.channel}}.{{item.key}}"
                                        [value]="item">
                                {{ item.trans | translate }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="col-sm-2">
                    <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                </div>
            </div>

            <div class="row">
                <div class="col-sm-10">
                    <mat-form-field class="full-width">
                        <mat-label>{{ recipientOptions.recipientIdLabel | translate }}</mat-label>
                        <input id="{{idPrefix}}input_text.{{recipientOptions.trans.recipient_id}}"
                               type="text" matInput
                               [(ngModel)]="recipientOptions.recipient_id"
                               [disabled]="disabled">
                    </mat-form-field>
                </div>

                <div class="col-sm-2">
                    <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                </div>
            </div>

            <div class="row"
                 *ngIf="recipientOptions.hasSubChannel">
                <div class="col-sm-10">
                    <mat-form-field class="full-width">
                        <mat-label>{{ recipientOptions.trans.sub_channel | translate }}</mat-label>
                        <mat-select id="{{idPrefix}}input_select.{{recipientOptions.trans.sub_channel}}"
                                    [(ngModel)]="selectedSubChannel"
                                    [disabled]="disabled">
                            <mat-option *ngFor="let item of subChannels"
                                        id="{{idPrefix}}input_select.{{recipientOptions.trans.sub_channel}}.{{item.key}}"
                                        [value]="item">
                                {{ item.trans | translate }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="col-sm-2">
                    <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                </div>
            </div>

        </div>

        <div class="col-md-12 col-lg-6">

            <div class="row">
                <div class="col-sm-10">
                    <mat-form-field class="full-width">
                        <mat-label>{{ recipientOptions.trans.max_filesize | translate }}</mat-label>
                        <input id="{{idPrefix}}input_text.{{recipientOptions.trans.max_filesize}}"
                               type="text" matInput
                               [(ngModel)]="recipientOptions.max_filesize"
                               [disabled]="disabled"
                               only-digits>
                    </mat-form-field>
                </div>

                <div class="col-sm-2 align-self-center">
                    MB
                </div>
            </div>

            <div class="row">
                <div class="col-sm-10">
                    <dr-checkbox [boolValue]="recipientOptions.merge_documents"
                                 [label]="recipientOptions.trans.merge_documents | translate"
                                 [idPrefix]="idPrefix"
                                 [idSuffix]="recipientOptions.trans.merge_documents"
                                 (updated)="recipientOptions.merge_documents = $event.value"
                                 [disabled]="disabled">
                    </dr-checkbox>
                </div>

                <div class="col-sm-2 align-self-center">
                    <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                </div>
            </div>

            <div class="row mt-2">
                <div class="col-sm-10">
                    <dr-checkbox [boolValue]="recipientOptions.remove_images"
                                 [label]="recipientOptions.trans.remove_images | translate"
                                 [idPrefix]="idPrefix"
                                 [idSuffix]="recipientOptions.trans.remove_images"
                                 (updated)="recipientOptions.remove_images = $event.value"
                                 [disabled]="disabled">
                    </dr-checkbox>
                </div>

                <div class="col-sm-2 align-self-center">
                    <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                </div>
            </div>

        </div>
    </div>

    <div class="row mt-5">

        <div class="offset-lg-6 col-xs-12 col-md-6 col-lg-3">
            <a id="{{idPrefix}}btn.cancel"
               mat-stroked-button
               color="primary"
               class="full-width"
               (click)="cancel()">
                {{ 'common.btn.cancel' | translate | uppercase }}
            </a>
        </div>

        <div class="col-xs-12 col-md-6 col-lg-3">
            <button id="{{idPrefix}}btn.save"
                    mat-flat-button
                    color="accent"
                    class="full-width"
                    (click)="submit()">
                {{ 'common.btn.save' | translate | uppercase }}
            </button>
        </div>

    </div>

</ng-container>
